import React, { useEffect, useRef } from 'react';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';

import ProfileEditInput from 'app/components/CommonStyled/ProfileEditInput';
import { Form, Formik, FormikProps } from 'formik';
import { postDreamProject } from 'services/profile-editor';
import {
  profileDataSelector,
  setDreamProject,
} from 'store/reducers/profile-editor/profile-editor-reducer';
import * as Yup from 'yup';

import ProfileEditorDrawer, { ProfileEditorDrawerRefProps } from '../Drawer';
import { ProfileEditorDrawerTitle } from '../styled';
import { ProfileEditorDrawerDreamProjectWrapper } from './styled';

interface ProfileEditorDrawerDreamProjectProps {
  onClose: () => void;
}

export default function ProfileEditorDrawerDreamProject({
  onClose,
}: ProfileEditorDrawerDreamProjectProps) {
  const dispatch = useDispatch();
  const formikRef = useRef<FormikProps<any>>(null);
  const drawerRef = useRef<ProfileEditorDrawerRefProps>(null);
  const { dream_project } = useSelector(profileDataSelector);

  const handlePostDreamProject = async (params: any) => {
    const response = await postDreamProject(params);
    if (!response.ok) {
      throw new Error(response.originalError?.message);
    }

    dispatch(setDreamProject(params.value));

    return response.data;
  };

  const dreamProjectValidationSchema = Yup.object().shape({
    dream_project: Yup.string().max(
      500,
      ({ value }) =>
        `${value.length - 500} ${
          value.length - 500 !== 1 ? 'characters' : 'character'
        } over the limit. Update your "Dream project" to fit within the limit to publish it to your profile!`
    ),
  });


  const { mutate } = useMutation(handlePostDreamProject, drawerRef.current?.handleMutation);

  const handleSubmit = (values) => {
    mutate({ value: values.dream_project });
  };

  return (
    <Formik
      initialValues={{
        dream_project,
      }}
      validationSchema={dreamProjectValidationSchema}
      onSubmit={handleSubmit}
      innerRef={formikRef}
    >
      {(props) => (
        <Form>
          <ProfileEditorDrawer
            ref={drawerRef}
            header={<ProfileEditorDrawerDreamProjectHeader />}
            needsSaving={Object.keys(props.touched).length > 0}
            onClose={onClose}
          >
            <ProfileEditorDrawerDreamProjectWrapper>
              <ProfileEditInput
                {...props}
                name={'dream_project'}
                label={
                  'Your current work is only part of the journey. Sharing meaningful initiatives, and where you would like to make your mark, is both inspirational and the first step towards turning your dreams into reality. What is your dream project?'
                }
                type={'text'}
                textLimit={500}
              />
            </ProfileEditorDrawerDreamProjectWrapper>
          </ProfileEditorDrawer>
        </Form>
      )}
    </Formik>
  );
}

function ProfileEditorDrawerDreamProjectHeader() {
  return <ProfileEditorDrawerTitle>Dream Project</ProfileEditorDrawerTitle>;
}
